<div mat-dialog-title  class="dialog-info">
    <label class="dialogTitle">
        {{'WARNING_TITLE' | translate}}    
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="dialogContent">
    <div class="dialogBody">
        <div class="iconSection">
            <mat-icon class="dialogIcon">warning</mat-icon>
        </div>
        <div class="dialogMessage">{{'WARNING_UNLOCK_CHECKLIST_MESSAGE' | translate}}</div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialogActionsBtns">
    <button mat-button color="primary" class="openCloseBtn mat-primary" mat-raised-button (click)="onConfirmClick()"
        >{{'OK_BTN' | translate}}</button>
    <button mat-button color="warn" class="openCloseBtn mat-primary" mat-raised-button mat-dialog-close>{{'CANCEL_BTN_LABEL' | translate}}</button>
</mat-dialog-actions>